export default {
    data: {
        key: 'funds',
        groups: [
            {
                headerName: 'Identifier',
                field: 'key',
            },
            {
                headerName: 'Name',
                field: 'name',
            },
            {
                headerName: 'Description',
                field: 'description',
            },
            {
                headerName: 'Group',
                field: 'group',
            },
            {
                headerName: 'Type',
                field: 'type',
            },
            {
                headerName: 'Validators',
                field: 'validators',
            },
            {
                headerName: 'Sources',
                field: 'mappers',
            },
            {
                headerName: 'Styles',
                field: 'styles',
            },
        ],
        fields: [
            {
                key: '1',
                name: 'Gp Id',
                description: 'Some description',
                type: 'int',
                validators: [],
                styles: [],
                mappers: {},
            },
            {
                key: '2',
                name: 'Name',
                description: 'Some description',
                type: 'string',
                validators: [],
                styles: [],
                mappers: {},
            },
            {
                key: '3',
                name: 'Hq Country Id',
                description: 'Some description',
                type: 'int',
                validators: [],
                styles: [],
                mappers: {},
            },
            {
                key: '4',
                name: 'Hq Region Id',
                description: 'Some description',
                type: 'select',
                styles: [],
                mappers: {},
            },
            {
                key: '5',
                name: 'Date',
                description: 'Some description',
                type: 'Date',
                validators: [],
                styles: [],
                mappers: {},
            },
            {
                key: '6',
                name: 'Gp Id',
                description: 'Some description',
                type: 'int',
                validators: [],
                styles: [],
                mappers: {},
            },
            {
                key: '7',
                name: 'Name',
                description: 'Some description',
                type: 'string',
                validators: [],
                styles: [],
                mappers: {},
            },
            {
                key: '8',
                name: 'Hq Country Id',
                description: 'Some description',
                type: 'int',
                validators: [],
                styles: [],
                mappers: {},
            },
            {
                key: '9',
                name: 'Hq Region Id',
                description: 'Some description',
                type: 'select',
                styles: [],
                mappers: {},
            },
            {
                key: '10',
                name: 'Date',
                description: 'Some description',
                type: 'Date',
                validators: [],
                styles: [],
                mappers: {},
            },
        ],
    },
}
